/*
SLB GENERATED FILE — DO NOT EDIT
Project: Saam Law BaseStation (SLB)
Build-Version: SLB_V4_133_JEE_CHAT_TRANSACTION_CONSOLE_20260910_01
Output: assets/slb.offline.js
Source: slb_src/slices/offline/
Build: slb_build/build_offline.mjs
Built: 2026-09-19 16:54:01.460Z
Content-SHA256: 6e8764ab689c95a64572754864fccf7d686190cb3f80f905015512aa087d1905
Content-SHA256-12: 6e8764ab689c
*/

/* MIGRATED SOURCE
   Original asset: /assets/slb.offline.js
*/

/* SLB Offline Mode — Phase 1 (2026-01-08)
 *
 * Goals:
 * - Local-first UX for selected admin actions (queue writes when offline).
 * - Manual + background sync.
 * - Lightweight read-cache for key screens.
 *
 * IMPORTANT:
 * - This is intentionally scoped to SLB pages only (loaded by saamlawbank-app snippet).
 * - We ONLY queue a small allowlist of actions to reduce risk.
 */
(function(){
  'use strict';

  var OUTBOX_KEY = 'slb_offline_outbox_v2_disabled';
  var RCACHE_KEY = 'slb_offline_readcache_v2';
  var SECURITY_MIGRATION_KEY = 'slb_security_migration_p521';
  var RCACHE_MAX_KEYS = 240;
  var OUTBOX_MAX = 200;

  var _rcacheMem = null;
  var _outboxMem = null;


  // Queue only the actions we explicitly want offline.
  // (Market has its own optimistic engine; keep it separate.)
  var QUEUE_OK = Object.freeze({});

  // Read cache (for offline viewing / reduced "jump")
  var RCACHE_OK = Object.freeze({
    libraryBootstrap: { ttlMs: 60*60*1000 },
    libraryList: { ttlMs: 5*60*1000 },
    libraryGet: { ttlMs: 24*60*60*1000 },
    cultGetTypes: { ttlMs: 24*60*60*1000 }
  });

  function currentCallsign(){
    try{
      return String(sessionStorage.getItem('tyw_callsign') || '').trim().toUpperCase() || 'ANON';
    }catch(_e){ return 'ANON'; }
  }

  function runSecurityMigration(){
    try{
      if(localStorage.getItem(SECURITY_MIGRATION_KEY) === '1') return;
      var remove = [];
      for(var i=0;i<localStorage.length;i++){
        var k = localStorage.key(i) || '';
        if(k === 'ty_auth_v1' ||
           k === 'slb_offline_outbox_v1' || k === 'slb_offline_readcache_v1' ||
           k === 'slb_offline_ticket_v1' || k === 'slb_offline_ticket_lock_v1' ||
           k === 'slb_offline_readcache_v2' ||
           k === 'slb_warm_cache_v1' || k === 'slb_warm_cache_v2' ||
           k === 'slb_warm_ui_mode' || k === 'slbImmersive' ||
           k.indexOf('slb_pagecache_') === 0 ||
           k.indexOf('slb_di_inbox_render_v2_nosnips_') === 0 ||
           k.indexOf('slb_tre_ops_') === 0){
          remove.push(k);
        }
      }
      remove.forEach(function(k){ try{ localStorage.removeItem(k); }catch(_e2){} });
      try{ if(window.indexedDB) indexedDB.deleteDatabase('slb_outbox_db_v1'); }catch(_e3){}
      localStorage.setItem(SECURITY_MIGRATION_KEY, '1');
    }catch(_e){}
  }

  runSecurityMigration();

  function safeParseJson(s, fallback){
    try{ return JSON.parse(s); }catch(_e){ return fallback; }
  }

  function stableStringify(value){
    var t = typeof value;
    if(value === null || t === 'number' || t === 'boolean') return JSON.stringify(value);
    if(t === 'string') return JSON.stringify(value);
    if(Array.isArray(value)){
      return '[' + value.map(stableStringify).join(',') + ']';
    }
    if(t === 'object'){
      var keys = Object.keys(value).sort();
      var parts = [];
      for(var i=0;i<keys.length;i++){
        var k = keys[i];
        parts.push(JSON.stringify(k) + ':' + stableStringify(value[k]));
      }
      return '{' + parts.join(',') + '}';
    }
    return 'null';
  }

  function djb2Hash(str){
    str = String(str || '');
    var h = 5381;
    for(var i=0;i<str.length;i++){
      h = ((h << 5) + h) + str.charCodeAt(i);
      h = h >>> 0;
    }
    return h.toString(16);
  }

  function genRequestId(){
    return 'r' + Date.now() + '_' + Math.random().toString(16).slice(2);
  }

  function genQueueId(){
    return 'q' + Date.now() + '_' + Math.random().toString(16).slice(2);
  }

  function nowIso(){
    try{ return new Date().toISOString(); }catch(_e){ return String(Date.now()); }
  }

  function loadOutbox(){
    _outboxMem = [];
    try{ localStorage.removeItem('slb_offline_outbox_v1'); }catch(_e){}
    return _outboxMem;
  }

  function saveOutbox(_arr){
    _outboxMem = [];
    try{ localStorage.removeItem('slb_offline_outbox_v1'); }catch(_e){}
  }

  function outboxCount(){
    var arr = loadOutbox();
    return (arr || []).filter(function(x){ return x && x.state !== 'done'; }).length;
  }

  function outboxCountNew_(){
    // Core persistent outbox (Phase 2+) meta key
    try{
      var s = localStorage.getItem('slb_outbox_meta_v1') || '';
      if(!s) return 0;
      var a = JSON.parse(s);
      if(!Array.isArray(a)) return 0;
      var n = 0;
      for(var i=0;i<a.length;i++){
        var it = a[i];
        if(!it) continue;
        var st = String(it.status||'');
        if(st && st !== 'done') n++;
      }
      return n;
    }catch(_e){ return 0; }
  }


  function loadReadCache(){
    if(_rcacheMem) return _rcacheMem;
    try{
      var raw = localStorage.getItem(RCACHE_KEY);
      var obj = safeParseJson(raw, {});
      _rcacheMem = (obj && typeof obj === 'object') ? obj : {};
      return _rcacheMem;
    }catch(_e){ _rcacheMem = {}; return _rcacheMem; }
  }

  function saveReadCache(obj){
    try{
      _rcacheMem = (obj && typeof obj === 'object') ? obj : {};
      localStorage.setItem(RCACHE_KEY, JSON.stringify(_rcacheMem));
    }catch(_e){
      _rcacheMem = (obj && typeof obj === 'object') ? obj : {};
    }
  }

  function readCacheKey(action, args){
    return currentCallsign() + '|' + String(action||'') + '|' + djb2Hash(stableStringify(args||{}));
  }

  function getReadCached(action, args){
    var cfg = RCACHE_OK[String(action||'')];
    if(!cfg) return null;
    var key = readCacheKey(action, args);
    var all = loadReadCache();
    var hit = all[key];
    if(!hit || !hit.ts) return null;
    var age = Date.now() - Number(hit.ts||0);
    if(age > Number(cfg.ttlMs||0)) return null;
    return hit.data;
  }

  // Like getReadCached, but returns cached data even if stale (useful for cache-first UI).
  // Returns either data (default) or meta if withMeta is true.
  function getReadCachedAny(action, args, withMeta){
    var cfg = RCACHE_OK[String(action||'')];
    if(!cfg) return null;
    var key = readCacheKey(action, args);
    var all = loadReadCache();
    var hit = all[key];
    if(!hit || !hit.ts) return null;
    var age = Date.now() - Number(hit.ts||0);
    var ttl = Number(cfg.ttlMs||0);
    var stale = (ttl > 0) ? (age > ttl) : false;
    if(withMeta){
      return { data: hit.data, ts: Number(hit.ts||0), ageMs: age, stale: stale };
    }
    return hit.data;
  }


  function setReadCached(action, args, data){
    var cfg = RCACHE_OK[String(action||'')];
    if(!cfg) return;
    var key = readCacheKey(action, args);
    var all = loadReadCache();
    all[key] = { ts: Date.now(), data: data };

    // simple prune by key count
    try{
      var keys = Object.keys(all);
      if(keys.length > RCACHE_MAX_KEYS){
        keys.sort(function(a,b){
          return Number((all[a]||{}).ts||0) - Number((all[b]||{}).ts||0);
        });
        var drop = keys.length - RCACHE_MAX_KEYS;
        for(var i=0;i<drop;i++) delete all[keys[i]];
      }
    }catch(_e){}

    saveReadCache(all);
  }

  function isNetworkErr(e){
    var m = String((e && e.message) ? e.message : e || '');
    return /script load failed|backend timeout|network|offline|failed to fetch|blocked/i.test(m);
  }

  function entityKeyFor(action, args){
    action = String(action||'');
    args = args || {};

    // Disciple entity
    if(action === 'adminDiscipleUpsert'){
      var d = args.disciple || {};
      var id = String(d.discipleId || '').trim();
      var cs = String(d.callsign || '').trim().toUpperCase();
      var bucket = String(args.bucket || d.bucket || '').trim().toUpperCase();
      return 'disc|' + (id || cs) + '|' + bucket;
    }
    if(action === 'adminDiscipleMove' || action === 'adminDiscipleDelete'){
      return 'disc|' + String(args.discipleId || args.callsign || '').trim().toUpperCase();
    }

    // Temple entity
    if(action === 'adminTempleOrderSetStatus' || action === 'adminTempleOrderArchive'){
      return 'tadm|' + String(args.orderId || '').trim();
    }
    if(action === 'templeOrderArchive'){
      return 'tmy|' + String(args.orderId || '').trim();
    }
    if(action === 'templeOrderCreateBulk'){
      return 'tcreate|' + djb2Hash(stableStringify(args||{}));
    }
    if(action === 'adminTempleArchiveDone'){
      return 'tadm_archdone';
    }
    if(action === 'adminTempleBlocksSaveAll'){
      return 'tadm_blocks';
    }

    return action + '|' + djb2Hash(stableStringify(args||{}));
  }

  function enqueue(action, args, requestId){
    action = String(action||'').trim();
    args = args || {};
    requestId = String(requestId || genRequestId());

    var box = loadOutbox();
    if(!Array.isArray(box)) box = [];

    // Prune if huge (keep newest)
    if(box.length > OUTBOX_MAX){
      box = box.slice(box.length - OUTBOX_MAX);
    }

    var eKey = entityKeyFor(action, args);

    // Replace existing queued item for the same entity+action (keeps queue clean)
    var replaced = false;
    for(var i=box.length-1;i>=0;i--){
      var it = box[i];
      if(!it) continue;
      if(String(it.action||'') === action && String(it.entityKey||'') === String(eKey||'')){
        it.args = args;
        it.requestId = requestId;
        it.state = 'queued';
        it.updatedAt = nowIso();
        it.lastError = '';
        replaced = true;
        break;
      }
    }

    var id;
    if(!replaced){
      id = genQueueId();
      box.push({
        id: id,
        requestId: requestId,
        action: action,
        args: args,
        entityKey: eKey,
        state: 'queued',
        attempts: 0,
        createdAt: nowIso(),
        updatedAt: nowIso(),
        lastError: ''
      });
    }

    saveOutbox(box);

    // Return the id of the last matching item
    if(!id){
      try{
        for(var j=box.length-1;j>=0;j--){
          if(String((box[j]||{}).action||'')===action && String((box[j]||{}).entityKey||'')===String(eKey||'')){
            id = box[j].id;
            break;
          }
        }
      }catch(_e){}
    }

    return { __queued: 1, queuedId: id || '', requestId: requestId };
  }

  // ===== UI Wiring =====
  var ui = {
    btn: null,
    badge: null,
    hint: null
  };

  function ensureUi(){
    if(ui.btn) return;
    ui.btn = document.getElementById('slbSyncBtn');
    ui.badge = document.getElementById('slbSyncBadge');
    ui.hint = document.getElementById('slbSyncHint');
    if(ui.btn && !ui.btn.__baseText){ ui.btn.__baseText = ui.btn.textContent || 'Sync'; }
    if(ui.btn && !ui.btn.__wired){
      ui.btn.__wired = true;
      ui.btn.addEventListener('click', function(){
        try{ api.syncNow({ user: 1 }); }catch(_e){}
      });
    }
  }

  function fmtTime(ts){
    try{
      if(!ts) return '';
      var d = new Date(ts);
      return d.toLocaleString();
    }catch(_e){ return ''; }
  }

  function updateUi(extra){
    ensureUi();
    var nOld = outboxCount();
    var nNew = outboxCountNew_();
    var n = nOld + nNew;
    var online = !!(navigator && navigator.onLine);

    if(ui.btn){
      var base = ui.btn.__baseText || 'Sync';
      var busyNew = false;
      try{ busyNew = !!(window.SLB_SYNC && window.SLB_SYNC.isBusy && window.SLB_SYNC.isBusy()); }catch(_e){}
      var busy = !!((extra && extra.syncing) || busyNew);
      if(!online){
        ui.btn.disabled = true;
        ui.btn.textContent = 'Offline';
      }else if(busy){
        ui.btn.disabled = true;
        ui.btn.textContent = 'Syncing…';
      }else if(!n){
        ui.btn.disabled = true;
        ui.btn.textContent = 'Synced';
      }else{
        ui.btn.disabled = false;
        ui.btn.textContent = base;
      }
    }

    if(ui.badge){
      ui.badge.textContent = n ? String(n) : '';
      ui.badge.style.display = n ? 'inline-flex' : 'none';
    }

    if(ui.hint){
      var busyNew2 = false;
      try{ busyNew2 = !!(window.SLB_SYNC && window.SLB_SYNC.isBusy && window.SLB_SYNC.isBusy()); }catch(_e){}
      var busy2 = !!((extra && extra.syncing) || busyNew2);

      var txt = (online ? 'Online' : 'Offline');

      if(busy2){
        txt = 'Syncing…';
        txt += ' • ' + (n ? (n + ' pending') : '0 pending');
      }else{
        if(!online){
          txt += ' • ' + (n ? (n + ' pending') : '0 pending');
        }else if(!n){
          txt += ' • Synced';
        }else{
          txt += ' • ' + n + ' pending';
        }
      }

      if(n && (nOld || nNew)){
        if(nOld && nNew) txt += ' (' + nOld + ' offline, ' + nNew + ' outbox)';
        else if(nOld) txt += ' (' + nOld + ' offline)';
        else if(nNew) txt += ' (' + nNew + ' outbox)';
      }

      if(extra && extra.lastSyncTs){
        txt += ' • Last: ' + fmtTime(extra.lastSyncTs);
      }
      if(extra && extra.note){
        txt += ' • ' + String(extra.note);
      }
      ui.hint.textContent = txt;
    }
  }

  // ===== RPC Wrap =====
  var origRpc = null;
  var wrapped = false;
  var syncing = false;
  var lastSyncTs = 0;

  var _revalInflight = Object.create(null);
  var _revalLastTs = Object.create(null);

  function wrapRpcIfReady(){
    if(wrapped) return true;
    var app = window.SLB_APP;
    if(!app || !app.rpc) return false;
    origRpc = app.rpc;
    if(!origRpc) return false;

    app.rpc = async function(action, args, opts){
      action = String(action||'').trim();
      args = args || {};
      opts = opts || {};

      // Read cache (offline open / snappier UX)
      var canReadCache = !!RCACHE_OK[action];
      var canQueue = !!QUEUE_OK[action];

      // If action is queueable, we ALWAYS pass a requestId so that:
      // - if the call succeeds, fine
      // - if it fails, we can queue with the same requestId (backend idempotency)
      var requestId = (canQueue ? (opts.requestId || genRequestId()) : (opts.requestId || ''));


      // Cache-first reads: show cached immediately (even if stale), then refresh in background.
      // This prevents the UI from going blank to "Loading..." when we already have local data.
      if(!canQueue && canReadCache && !(opts && (opts.noCacheFirst || opts.noCache))){
        var meta = getReadCachedAny(action, args, true);
        if(meta && meta.data != null){
          var cached = meta.data;
          try{
            if(cached && typeof cached === 'object'){
              cached.__cached = 1;
              if(meta.stale) cached.__stale = 1;
            }
          }catch(_e0){}
          try{
            if(navigator && navigator.onLine !== false){
              scheduleRevalidate(action, args, opts, requestId, meta);
            }
          }catch(_e1){}
          return cached;
        }
      }


      // Short-circuit: offline + queueable
      if(canQueue && navigator && navigator.onLine === false){
        var q = enqueue(action, args, requestId);
        try{ updateUi({ lastSyncTs:lastSyncTs, note:'Queued' }); }catch(_e){}
        return q;
      }

      // Short-circuit: offline + read-cacheable (stale allowed)
      if(!canQueue && canReadCache && navigator && navigator.onLine === false){
        var cached0m = getReadCachedAny(action, args, false);
        if(cached0m != null){
          try{ if(cached0m && typeof cached0m === 'object') cached0m.__cached = 1; }catch(_e0){}
          return cached0m;
        }
      }

      try{
        var out = await origRpc(action, args, requestId ? Object.assign({}, opts, { requestId: requestId }) : opts);
        try{
          if(canReadCache){
            setReadCached(action, args, out);
            try{ window.dispatchEvent(new CustomEvent('slb:cacheUpdated', { detail: { action: action, key: readCacheKey(action, args) } })); }catch(_e2b){}
          }
        }catch(_e2){}
        return out;
      }catch(e){
        // Network error: return cached reads, or queue writes.
        if(isNetworkErr(e)){
          if(canQueue){
            var q2 = enqueue(action, args, requestId);
            try{ q2.__queuedReason = String((e && e.message) ? e.message : e || ''); }catch(_e3){}
            try{ updateUi({ lastSyncTs:lastSyncTs, note:'Queued' }); }catch(_e4){}
            return q2;
          }
          if(canReadCache){
            var cached1 = getReadCachedAny(action, args, false);
            if(cached1 != null){
              try{ if(cached1 && typeof cached1 === 'object') cached1.__cached = 1; }catch(_e5){}
              return cached1;
            }
          }
        }
        throw e;
      }
    };

    wrapped = true;
    updateUi({ lastSyncTs:lastSyncTs });
    return true;
  }

  
  // Cache-first (stale-while-revalidate): show cached immediately, refresh quietly in background.
  function scheduleRevalidate(action, args, opts, requestId, meta){
    try{
      if(!origRpc) return;
      var cfg = RCACHE_OK[String(action||'')];
      if(!cfg) return;
      var key = readCacheKey(action, args);
      var now = Date.now();

      // throttle per key
      var minGap = 1500;
      if(_revalInflight[key]) return;
      if(_revalLastTs[key] && (now - _revalLastTs[key] < minGap)) return;

      var ttl = Number(cfg.ttlMs||0);
      var age = Number(meta && meta.ageMs || (now - Number(meta && meta.ts || 0)));
      var threshold = Math.max(3000, (ttl > 0 ? Math.min(15000, Math.floor(ttl/2)) : 5000));
      var needs = (meta && meta.stale) || (age > threshold);
      if(!needs) return;

      _revalLastTs[key] = now;
      _revalInflight[key] = 1;

      Promise.resolve().then(async function(){
        try{
          var out = await origRpc(action, args, requestId ? Object.assign({}, opts || {}, { requestId: requestId }) : (opts || {}));
          try{ setReadCached(action, args, out); }catch(_e1){}
          try{ window.dispatchEvent(new CustomEvent('slb:cacheUpdated', { detail: { action: action, key: key } })); }catch(_e2){}
        }catch(_e3){}finally{
          try{ delete _revalInflight[key]; }catch(_e4){ _revalInflight[key] = 0; }
        }
      });
    }catch(_e){}
  }

async function syncNow(opts){
    if(syncing) return;
    if(!wrapRpcIfReady()) return;
    if(!navigator || navigator.onLine === false) { updateUi({ lastSyncTs:lastSyncTs, note:'Offline' }); return; }

    syncing = true;
    updateUi({ syncing:true, lastSyncTs:lastSyncTs });

    // Phase 4: also flush the core Outbox queue (Phase 2/3) if available
    var newErr = '';
    try{
      if(window.SLB_SYNC && typeof window.SLB_SYNC.flushQueue === 'function'){
        await window.SLB_SYNC.flushQueue(true);
      }
    }catch(e){
      newErr = String((e && e.message) ? e.message : e || '');
    }

    var box = loadOutbox();
    if(!Array.isArray(box)) box = [];
    if(!box.length){ syncing=false; updateUi({ lastSyncTs:lastSyncTs }); return; }

    // Process sequentially (keeps backend locks lower risk)
    var changed = false;

    for(var i=0;i<box.length;i++){
      var it = box[i];
      if(!it || it.state === 'done') continue;

      // Skip non-queueable (safety)
      if(!QUEUE_OK[String(it.action||'')]){ it.state='failed'; it.lastError='Not allowed to sync.'; continue; }

      it.state = 'syncing';
      it.attempts = Number(it.attempts||0) + 1;
      it.updatedAt = nowIso();
      saveOutbox(box);
      changed = true;

      try{
        await origRpc(String(it.action||''), it.args || {}, { requestId: String(it.requestId||genRequestId()) });
        it.state = 'done';
        it.updatedAt = nowIso();
        it.lastError = '';
        saveOutbox(box);
      }catch(e){
        var msg = String((e && e.message) ? e.message : e || 'Sync failed');
        it.state = isNetworkErr(e) ? 'queued' : 'failed';
        it.lastError = msg;
        it.updatedAt = nowIso();
        saveOutbox(box);

        // If network died mid-sync, stop now.
        if(isNetworkErr(e)) break;
      }
    }

    // Compact done items
    try{
      var box2 = loadOutbox();
      box2 = (box2||[]).filter(function(x){ return x && x.state !== 'done'; });
      saveOutbox(box2);
    }catch(_e){}

    syncing = false;
    lastSyncTs = Date.now();
    updateUi({ lastSyncTs:lastSyncTs });

    // User-triggered: show a concise result toast (normal mode)
    try{
      if(opts && opts.user){
        var rem = outboxCount() + outboxCountNew_();
        var msg = '';
        if(!navigator || navigator.onLine === false) msg = 'Offline — ' + rem + ' pending';
        else if(rem <= 0) msg = 'Synced.';
        else msg = 'Sync done — ' + rem + ' pending';
        if(newErr) msg = msg + ' (partial)';
        if(window.SLB && window.SLB.ui && window.SLB.ui.toast) window.SLB.ui.toast(msg, 2400);
      }
    }catch(_e){}
  }

  // ===== Offline authentication disabled =====
  // A four-digit PIN cannot safely protect a reusable server token stored on disk.
  // Normal online login remains available; offline mode is limited to safe read-only cache.
  function clearSecurityState(){
    try{ localStorage.removeItem('slb_offline_ticket_v1'); }catch(_e){}
    try{ localStorage.removeItem('slb_offline_ticket_lock_v1'); }catch(_e2){}
    try{ localStorage.removeItem('slb_offline_outbox_v1'); }catch(_e3){}
    try{ localStorage.removeItem(RCACHE_KEY); }catch(_e4){}
    try{ if(window.indexedDB) indexedDB.deleteDatabase('slb_outbox_db_v1'); }catch(_e5){}
    _outboxMem = [];
    _rcacheMem = {};
  }

  window.SLB_OFFAUTH = {
    hasTicket: function(){ return false; },
    armFromLogin: function(){ return Promise.resolve(false); },
    tryUnlock: function(){ return Promise.reject(new Error('Offline sign-in is disabled for security. Connect to the internet and log in.')); },
    clear: clearSecurityState
  };

  // ===== Public API =====
  var api = {
    version: 'phase2-security',
    isOnline: function(){ return !!(navigator && navigator.onLine); },
    queueCount: function(){ return outboxCount() + outboxCountNew_(); },
    syncNow: syncNow,
    peekRead: function(action, args){ return getReadCachedAny(action, args, false); },
    peekReadMeta: function(action, args){ return getReadCachedAny(action, args, true); },
    clearLocalData: clearSecurityState,
    _wrap: wrapRpcIfReady
  };

  window.SLB_OFFLINE = api;

  // ===== Boot =====
  // V4.10: SLB_APP readiness is event-owned. The old implementation polled
  // every 300ms for up to ~18 seconds. Shared core/RPC/auth events now wake the
  // wrapper immediately; a few bounded one-shots remain only for compatibility.
  var offlineRuntimeBound_ = false;
  var offlineReadinessDone_ = false;
  function offlineDetachReadiness_(){
    try{ window.removeEventListener('slb:core-ready', offlineTryWrap_); }catch(_e1){}
    try{ window.removeEventListener('slb:rpc-ready', offlineTryWrap_); }catch(_e2){}
    try{ window.removeEventListener('slb:auth-ready', offlineTryWrap_); }catch(_e3){}
  }
  function offlineBindRuntimeEvents_(){
    if(offlineRuntimeBound_) return;
    offlineRuntimeBound_ = true;
    // Auto-sync when coming online
    try{ window.addEventListener('online', function(){
      updateUi({ lastSyncTs:lastSyncTs });
      // small delay lets the browser fully reconnect
      setTimeout(function(){ try{ syncNow(); }catch(_e){} }, 900);
    }); }catch(_e4){}

    // V4.3: the legacy offline write queue is disabled, so there is no reason
    // to wake the whole app every 15 seconds. Core outbox changes are explicit
    // events; use those plus online/visibility/manual Sync instead.
    try{ window.addEventListener('slb:outbox-changed', function(){
      try{ updateUi({ lastSyncTs:lastSyncTs }); }catch(_e){}
    }); }catch(_e5){}
  }
  function offlineTryWrap_(){
    if(offlineReadinessDone_) return true;
    if(!wrapRpcIfReady()) return false;
    offlineReadinessDone_ = true;
    offlineDetachReadiness_();
    offlineBindRuntimeEvents_();
    return true;
  }
  try{ window.addEventListener('slb:core-ready', offlineTryWrap_); }catch(_e6){}
  try{ window.addEventListener('slb:rpc-ready', offlineTryWrap_); }catch(_e7){}
  try{ window.addEventListener('slb:auth-ready', offlineTryWrap_); }catch(_e8){}
  offlineTryWrap_();
  setTimeout(offlineTryWrap_, 1200);
  setTimeout(offlineTryWrap_, 5000);
  setTimeout(function(){
    if(!offlineTryWrap_()){
      try{ updateUi({ note:'(offline wrapper not ready)' }); }catch(_e9){}
    }
  }, 18000);

  // Update UI on focus/visibility changes
  try{
    document.addEventListener('visibilitychange', function(){
      if(!document.hidden) updateUi({ lastSyncTs:lastSyncTs });
    });
    window.addEventListener('focus', function(){ updateUi({ lastSyncTs:lastSyncTs }); });
  }catch(_e4){}

  // Lazy UI init
  setTimeout(function(){ try{ updateUi({ lastSyncTs:lastSyncTs }); }catch(_e){} }, 800);
})();

